import Form from "./Form"
import TermsTable from "./TermsTable"
import TermContext from "./termsContext"
import { Typography } from "antd"
import { useEffect, useState } from "react"
import { GetPBTermsInterface } from "@type/payBill.types"
import { getEmployeesTermByEmployeeId } from "store/Employee/Terms/terms.slice"
import { useAppDispatch, useAppSelector } from "hooks"
import { getPBTerms, isPBTermLoading, selectPBTermList } from "../../../store/PayBill/PBTerms.slice"
import useSchedulesQueryParams from "hooks/useSchedulesQueryParams"
import { useEmployeeScheduleDefaults } from "hooks/useScheduleDefaults"

const Terms = () => {
	const dispatch = useAppDispatch()
	useEmployeeScheduleDefaults()
	const { selectedEmployee = "" } = useSchedulesQueryParams()
	const [pbTerm, setPbTerm] = useState<GetPBTermsInterface | null>(null)
	const pbTerms = useAppSelector(selectPBTermList)
	const isPbTermLoading = useAppSelector(isPBTermLoading())

	useEffect(() => {
		selectedEmployee && dispatch(getEmployeesTermByEmployeeId(selectedEmployee))
		setPbTerm(null)
	}, [selectedEmployee])

	useEffect(() => {
		dispatch(getPBTerms())
	}, [])

	const handleRow = (e: any) => setPbTerm(e)

	return (
		<TermContext.Provider value={{ handleRow, pbTerm, pbTerms, isPbTermLoading }}>
			<div className="grid grid-cols-12 gap-x-10">
				<div className="col-span-3">
					<Form />
				</div>
				<div className="col-span-9">
					<Typography.Title level={5}>All Terms</Typography.Title>
					<TermsTable />
				</div>
			</div>
		</TermContext.Provider>
	)
}

export default Terms
